import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/account`
    },
    getAccountCached: {
        method: 'GET',
        url: `${BASE_PATH_API}/account`
    },
    getAccountInfoLimited: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/limited`
    },
    getBillingInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/billing`
    },
    getDefaultPricingPlans: {
        method: 'GET',
        url: `${BASE_PATH_API}/achbilling/defaults`
    },
    getCurrentPricingPlan: {
        method: 'GET',
        url: `${BASE_PATH_API}/achbilling/currentPlan`
    },
    getIsSubscriptionPlanEditDisabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/achBilling/isSubscriptionPlanEditDisabled`
    },
    updateAccount: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account`
    },
    getAccountOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/adminstrators`
    },
    getAccountPublicSiteInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/publicSite`
    },
    validateUserAccessByNavigationPath: {
        method: 'GET',
        url: `${BASE_PATH_API}/navigation/validate?destination=:navPath`
    }
};

export function AccountAndBillingApi() {
    return createActions(actions);
}
